<!-- Agent Main Area - Content area that switches between hub and agent views -->
<div class="agent-main-area">

  <!-- Content Area -->
  <div class="main-content">
    
    <!-- Agent Hub View (All Agents Grid) -->
    <div class="hub-view" *ngIf="isAgentHubMode" class = "agent-home-page-container">
      <app-agent-hub 
      [chatbotComponentRef]="chatbotComponentRef" >
      </app-agent-hub>
    </div>
    <!-- AI Workbench (iframe from config WorkbenchUrl gated by feature flag ∩ privilege) -->
    <div class="ai-workbench-view" *ngIf="!isAgentHubMode && currentAgentId === aiWorkbenchAgentId && workbenchAccessAllowed">
      <iframe
        #aiWorkbenchIframe
        *ngIf="safeAiWorkbenchUrl"
        [src]="safeAiWorkbenchUrl"
        title="AI Workbench"
        allowfullscreen
        allow="clipboard-read; clipboard-write; microphone"
        class="ai-workbench-iframe"
        (load)="onAiWorkbenchIframeLoad($event)"></iframe>
      <div *ngIf="!safeAiWorkbenchUrl" class="ai-workbench-fallback" role="status">
        {{ 'AI_WORKBENCH_CONFIG_MISSING' | translate }}
      </div>
    </div>

    <div class="ai-workbench-view" *ngIf="!isAgentHubMode && currentAgentId === aiWorkbenchAgentId && !workbenchAccessAllowed">
      <div class="ai-workbench-fallback" role="alert">
        {{ 'AI_WORKBENCH_ACCESS_DENIED' | translate }}
      </div>
    </div>

    <!-- Agent Chat Container (Selected Agent) -->
    <div class="agent-view" *ngIf="!isAgentHubMode && currentAgentId && currentAgentId !== aiWorkbenchAgentId">
      <app-agent-chat-container
        [loaderShow]="loaderShow"
        [userFName]="userFName"
        [chatbotComponentRef]="chatbotComponentRef"
        [isSidebarOpen]="isSidebarOpen"
        (requestCloseSidebar)="requestCloseSidebar.emit()">
      </app-agent-chat-container>
    </div>

  </div>

</div>
